import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import client, { setGlobalErrorHandler } from "../services/client";
import { CustomError, SessionExpiredPopup } from "../components";
import { STORAGE_KEYS } from "../constants";
import { getSessionStorage } from "../utils/storageUtils";

export const ErrorContext = createContext(null);
export const useErrorHandler = () => useContext(ErrorContext);

const ApiErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [customError, setCustomError] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);

  const location = useLocation();
  const hasShownSessionPopup = useRef(false);
  console.log(sessionExpired, "sessionExpired");
  useEffect(() => {
    setGlobalErrorHandler((err) => {
      if (err?.type === "SESSION_EXPIRED") {
        if (!hasShownSessionPopup.current) {
          hasShownSessionPopup.current = true;
          setSessionExpired(true);
        }
        return;
      }

      // existing error handling
      setError(err);
    });
  }, []);

  useEffect(() => {
    setShowPopup(!!error);
  }, [error]);

  const isShortLinkRoute = location.pathname.startsWith("/s/");

  const handleTryAgain = () => {
    setShowPopup(false);
    retryFailedRequest();
  };

  const retryFailedRequest = async () => {
    try {
      return await client(error.requestConfig);
    } catch (error) {
      console.error(error, "Error in retryFailedRequest api:");
    }
  };

  const handleSessionLogout = () => {
    const storePath = getSessionStorage(STORAGE_KEYS.CUSTOM_PATH);
    sessionStorage.clear();
    window.location.replace(`/app/${storePath}`);
  };

  return (
    <ErrorContext.Provider value={{ setCustomError }}>
      {children}

      {error && !isShortLinkRoute && (
        <CustomError
          requestId={error.requestId}
          showPopup={showPopup}
          handleTryAgain={handleTryAgain}
        />
      )}

      {customError && (
        <CustomError
          showPopup
          title={customError.title}
          message={customError.message}
          hideRequestSection
        />
      )}

      <SessionExpiredPopup
        show={sessionExpired}
        onClickConfirm={handleSessionLogout}
      />
    </ErrorContext.Provider>
  );
};

export default ApiErrorProvider;
